import { render } from "./Plus.vue?vue&type=template&id=0f08f3d8"
const script = {}
script.render = render

export default script